(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-scents"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scent-filters')) {
    customElements.define(
      'scent-filters',
      class ScentFilters extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-scents-grid]');
          this.emptyMessage = this.querySelector('[data-scents-empty]');
          if (!this.grid) return;

          this.cards = Array.from(this.grid.querySelectorAll('.scent-card'));
          this.clearButtons = Array.from(this.querySelectorAll('[data-clear-filter]'));

          this.addEventListener('change', (event) => {
            if (event.target.name === 'sort_by') {
              this.sort(event.target.value);
            } else if (event.target.name === 'fragrance_family' || event.target.name === 'strength') {
              this.filter();
              this.updateClearButtons();
            }
          });

          this.clearButtons.forEach((button) => {
            button.addEventListener('click', () => {
              const name = button.dataset.clearFilter;
              this.querySelectorAll(`input[name="${name}"]:checked`).forEach((input) => {
                input.checked = false;
              });
              this.filter();
              this.updateClearButtons();
              button.closest('.scent-filters__dropdown').open = false;
            });
          });

          const dropdowns = this.querySelectorAll('.scent-filters__dropdown');
          dropdowns.forEach((dropdown) => {
            dropdown.addEventListener('toggle', () => {
              if (!dropdown.open) return;
              dropdowns.forEach((other) => {
                if (other !== dropdown) other.open = false;
              });
            });
          });

          document.addEventListener('click', (event) => {
            dropdowns.forEach((dropdown) => {
              if (dropdown.open && !dropdown.contains(event.target)) dropdown.open = false;
            });
          });

          this.updateClearButtons();
        }

        updateClearButtons() {
          this.clearButtons.forEach((button) => {
            const hasSelection = this.querySelector(`input[name="${button.dataset.clearFilter}"]:checked`) !== null;
            button.closest('[data-clear-item]').hidden = !hasSelection;
          });
        }

        filter() {
          const families = Array.from(this.querySelectorAll('input[name="fragrance_family"]:checked')).map((el) => el.value);
          const strengths = Array.from(this.querySelectorAll('input[name="strength"]:checked')).map((el) => el.value);

          let visibleCount = 0;
          this.cards.forEach((card) => {
            const matchesFamily = families.length === 0 || families.includes(card.dataset.fragranceFamily);
            const matchesStrength = strengths.length === 0 || strengths.includes(card.dataset.strength);
            const visible = matchesFamily && matchesStrength;
            card.classList.toggle('is-filtered-out', !visible);
            if (visible) visibleCount += 1;
          });

          if (this.emptyMessage) {
            this.emptyMessage.hidden = visibleCount !== 0;
          }
        }

        sort(value) {
          const [key, direction] = value.split('-');
          const sorted = [...this.cards].sort((a, b) => {
            let aValue;
            let bValue;
            if (key === 'strength') {
              aValue = Number(a.dataset.strength) || 0;
              bValue = Number(b.dataset.strength) || 0;
            } else {
              aValue = a.querySelector('.scent-card__name')?.textContent.trim().toLowerCase() || '';
              bValue = b.querySelector('.scent-card__name')?.textContent.trim().toLowerCase() || '';
            }
            if (aValue < bValue) return direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return direction === 'asc' ? 1 : -1;
            return 0;
          });

          sorted.forEach((card) => this.grid.appendChild(card));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-articles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blog-articles-list')) {
    customElements.define(
      'blog-articles-list',
      class BlogArticlesList extends HTMLElement {
        connectedCallback() {
          const showMoreButton = this.querySelector('[data-show-more-trigger]');
          if (!showMoreButton) return;

          showMoreButton.addEventListener('click', () => {
            this.querySelectorAll('.article-card.is-overflow').forEach((card) => {
              card.classList.remove('is-overflow');
            });
            showMoreButton.closest('.blog-articles__footer').remove();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('cart-page')) {
    customElements.define(
      'cart-page',
      class CartPage extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('.cart-page__content');
          this.sectionId = this.dataset.sectionId;
          this.busy = false;

          this.addEventListener('click', this.handleClick.bind(this));
          this.addEventListener('change', this.handleChange.bind(this));
        }

        handleClick(event) {
          const row = event.target.closest('[data-line-key]');
          if (!row) return;

          if (event.target.closest('[data-remove-item]')) {
            event.preventDefault();
            this.updateLine(row.dataset.lineKey, 0);
            return;
          }

          const input = row.querySelector('[data-quantity-input]');
          if (!input) return;

          if (event.target.closest('[data-quantity-decrease]')) {
            input.value = Math.max(0, Number(input.value) - 1);
            this.updateLine(row.dataset.lineKey, Number(input.value));
          } else if (event.target.closest('[data-quantity-increase]')) {
            // At the line's stock cap + is only aria-disabled, so the press
            // still lands here and can explain why nothing happened.
            if (event.target.closest('[data-quantity-increase]').getAttribute('aria-disabled') === 'true') {
              window.alert(this.dataset.onlyAvailable.replace('[quantity]', input.max || input.value));
              return;
            }
            input.value = this.capQuantity(input, Number(input.value) + 1);
            this.updateLine(row.dataset.lineKey, Number(input.value));
          }
        }

        handleChange(event) {
          const input = event.target.closest('[data-quantity-input]');
          if (!input) return;

          const row = input.closest('[data-line-key]');
          if (!row) return;

          const requested = Math.max(0, Number(input.value) || 0);
          input.value = this.capQuantity(input, requested);
          if (requested > Number(input.value)) {
            // Same alert-style feedback as a Shopify-side stock rejection
            // in updateLine, so the shopper knows why their number shrank.
            window.alert(this.dataset.onlyAvailable.replace('[quantity]', input.value));
          }
          this.updateLine(row.dataset.lineKey, Number(input.value));
        }

        // Clamps to the input's `max` — the line's stock cap, rendered by
        // cart-line-stock-max.liquid (absent when the variant isn't
        // stock-limited).
        capQuantity(input, quantity) {
          return input.max ? Math.min(quantity, Number(input.max)) : quantity;
        }

        updateLine(lineKey, quantity) {
          if (this.busy) {
            this.queued = { lineKey, quantity };
            return;
          }
          this.busy = true;

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: lineKey,
              quantity,
              sections: `header,${this.sectionId}`,
              sections_url: window.location.pathname,
            }),
          })
            .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
            .then(({ ok, data }) => {
              if (ok) {
                this.render(data);
              } else {
                // Shopify rejected the change (most commonly: not enough
                // stock left) — `description`/`message` is the
                // human-readable reason. Reload afterwards so the cart
                // reflects its real, unchanged state instead of the
                // optimistic quantity we'd already set on the input.
                window.alert(data.description || data.message || 'Something went wrong updating your cart.');
                window.location.reload();
              }
            })
            .catch(() => {
              window.location.reload();
            })
            .finally(() => {
              this.busy = false;

              if (this.queued) {
                const next = this.queued;
                this.queued = null;
                this.updateLine(next.lineKey, next.quantity);
              }
            });
        }

        render(data) {
          if (!data || !data.sections) {
            window.location.reload();
            return;
          }

          // This page doesn't dispatch `cart:updated` (see the top comment),
          // so hand the fresh cart to the shared stock caps directly.
          if (window.StockLimits) window.StockLimits.setCart(data);

          const pageHtml = data.sections[this.sectionId];
          const parsed = pageHtml ? new DOMParser().parseFromString(pageHtml, 'text/html') : null;
          const newContent = parsed ? parsed.querySelector('.cart-page__content') : null;

          if (newContent) {
            this.content.innerHTML = newContent.innerHTML;
          } else {
            // The requested section didn't come back as expected (e.g. an
            // id mismatch) — fall back to a full reload so the change the
            // shopper just made is never silently lost.
            window.location.reload();
            return;
          }

          const headerHtml = data.sections.header;
          if (headerHtml) {
            const parsed = new DOMParser().parseFromString(headerHtml, 'text/html');
            const newCartLink = parsed.querySelector('.header__cart');
            const cartLink = document.querySelector('.header__cart');
            if (newCartLink && cartLink) cartLink.innerHTML = newCartLink.innerHTML;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-filters')) {
    customElements.define(
      'collection-filters',
      class CollectionFilters extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;

          const form = this.querySelector('[data-collection-filter-form]');
          if (form) {
            form.addEventListener('change', () => this.onFilterChange(form));
          }

          const filters = this.querySelector('.collection-filters');
          const toggle = this.querySelector('[data-filters-toggle]');
          if (toggle && filters) {
            toggle.addEventListener('click', () => filters.classList.toggle('is-open'));
          }

          const applyButton = this.querySelector('[data-filters-apply]');
          if (applyButton && filters) {
            applyButton.addEventListener('click', () => filters.classList.remove('is-open'));
          }

          this.dropdowns = this.querySelectorAll('.collection-filters__item, .collection-filters__sort');
          this.dropdowns.forEach((dropdown) => {
            dropdown.addEventListener('toggle', () => {
              if (!dropdown.open) return;
              this.dropdowns.forEach((other) => {
                if (other !== dropdown) other.open = false;
              });
            });
          });

          this.handleDocumentClick = (event) => {
            this.dropdowns.forEach((dropdown) => {
              if (dropdown.open && !dropdown.contains(event.target)) dropdown.open = false;
            });
          };
          document.addEventListener('click', this.handleDocumentClick);

          const showMoreButton = this.querySelector('[data-show-more-trigger]');
          if (showMoreButton) {
            showMoreButton.addEventListener('click', () => {
              this.querySelectorAll('.product-card.is-overflow').forEach((card) => {
                card.classList.remove('is-overflow');
              });
              showMoreButton.closest('.collection__show-more').remove();
            });
          }

          this.addEventListener('click', (event) => {
            const link = event.target.closest(
              'a.collection__pagination-link, a.collection__pagination-arrow, a[data-filter-remove]'
            );
            if (!link) return;

            event.preventDefault();
            const isPageChange = !link.matches('[data-filter-remove]');
            this.fetchSection(link.href, true, isPageChange);
          });
        }

        disconnectedCallback() {
          if (this.handleDocumentClick) {
            document.removeEventListener('click', this.handleDocumentClick);
          }
        }

        onFilterChange(form) {
          const params = new URLSearchParams(new FormData(form));
          const query = params.toString();
          const url = `${window.location.pathname}${query ? '?' + query : ''}`;
          this.fetchSection(url, true);
        }

        setLoading(isLoading) {
          this.classList.toggle('is-loading', isLoading);
          this.setAttribute('aria-busy', isLoading ? 'true' : 'false');
          if (isLoading && this.dropdowns) {
            this.dropdowns.forEach((dropdown) => {
              dropdown.open = false;
            });
          }
        }

        fetchSection(url, updateHistory, scrollToTop = false) {
          this.setLoading(true);

          const separator = url.includes('?') ? '&' : '?';
          const fetchUrl = `${url}${separator}section_id=${this.sectionId}`;

          fetch(fetchUrl)
            .then((response) => response.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fresh = doc.getElementById(`CollectionSection-${this.sectionId}`);
              if (fresh) {
                this.replaceWith(fresh);
              } else {
                this.setLoading(false);
              }
              if (updateHistory) {
                window.history.pushState({}, '', url);
              }
              if (scrollToTop) {
                const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
              }
            })
            .catch(() => {
              this.setLoading(false);
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = 300;
    const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';

    class FaqItem {
      constructor(details) {
        this.details = details;
        this.summary = details.querySelector('summary');
        this.wrapper = details.querySelector('.faq-item__answer-wrapper');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        this.details.dataset.expanded = this.details.open ? 'true' : 'false';
        this.summary.addEventListener('click', (event) => this.onClick(event));
      }

      onClick(event) {
        if (reduceMotion || !this.wrapper) return;
        event.preventDefault();

        this.details.dataset.expanded = this.details.open && !this.isClosing ? 'false' : 'true';

        if (this.isClosing || !this.details.open) {
          this.expand();
        } else if (this.isExpanding || this.details.open) {
          this.shrink();
        }
      }

      shrink() {
        this.isClosing = true;
        const startHeight = `${this.wrapper.offsetHeight}px`;
        if (this.animation) this.animation.cancel();
        this.animation = this.wrapper.animate({ height: [startHeight, '0px'] }, { duration, easing });
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => {
          this.isClosing = false;
        };
      }

      expand() {
        // Pin the wrapper's current (collapsed) height as an inline style
        // before flipping `open` — otherwise the CSS fallback rule
        // `[open] .faq-item__answer-wrapper { height: auto }` snaps it to
        // full height immediately, so the rAF callback below would measure
        // an already-equal start/end height and nothing would animate.
        this.wrapper.style.height = `${this.wrapper.offsetHeight}px`;
        this.details.open = true;
        window.requestAnimationFrame(() => {
          this.isExpanding = true;
          const startHeight = `${this.wrapper.offsetHeight}px`;
          const endHeight = `${this.wrapper.scrollHeight}px`;
          if (this.animation) this.animation.cancel();
          this.animation = this.wrapper.animate({ height: [startHeight, endHeight] }, { duration, easing });
          this.animation.onfinish = () => this.onAnimationFinish(true);
          this.animation.oncancel = () => {
            this.isExpanding = false;
          };
        });
      }

      onAnimationFinish(open) {
        this.details.open = open;
        this.details.dataset.expanded = open ? 'true' : 'false';
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.wrapper.style.height = '';
      }
    }

    customElements.define(
      'faq-accordion',
      class FaqAccordion extends HTMLElement {
        connectedCallback() {
          const items = this.querySelectorAll('details');
          items.forEach((item) => new FaqItem(item));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-blog-slider')) {
    customElements.define(
      'featured-blog-slider',
      class FeaturedBlogSlider extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.featured-blog');
          if (!section) return;

          this.prevButton = section.querySelector('[data-direction="prev"]');
          this.nextButton = section.querySelector('[data-direction="next"]');

          section.querySelectorAll('[data-direction]').forEach((button) => {
            button.addEventListener('click', () => {
              const card = this.querySelector('.featured-blog__card');
              const distance = card ? card.getBoundingClientRect().width + 24 : this.clientWidth;
              const direction = button.dataset.direction === 'prev' ? -1 : 1;
              this.scrollBy({ left: distance * direction, behavior: 'smooth' });
            });
          });

          this.updateNavButtons();
          this.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
          window.addEventListener('resize', () => this.updateNavButtons());
        }

        // Where a card's own scrollLeft would land if centered — clamped to
        // the track's real scroll range. Used instead of raw scrollWidth so
        // the mobile centering padding past the last card (see stylesheet)
        // isn't counted as more room left to scroll.
        getCenteredScrollLeft(card) {
          const maxScrollLeft = Math.max(this.scrollWidth - this.clientWidth, 0);
          const target = card.offsetLeft + card.offsetWidth / 2 - this.clientWidth / 2;
          return Math.min(Math.max(target, 0), maxScrollLeft);
        }

        updateNavButtons() {
          const cards = Array.from(this.querySelectorAll('.featured-blog__card:not([hidden])'));
          if (!cards.length) return;

          const lastCardTarget = this.getCenteredScrollLeft(cards[cards.length - 1]);
          if (this.prevButton) this.prevButton.hidden = this.scrollLeft <= 0;
          if (this.nextButton) this.nextButton.hidden = this.scrollLeft >= lastCardTarget - 1;
        }
      }
    );
  }

  if (!customElements.get('featured-blog-search')) {
    customElements.define(
      'featured-blog-search',
      class FeaturedBlogSearch extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.featured-blog');
          this.input = this.querySelector('.featured-blog__search-input');
          this.cards = this.section ? Array.from(this.section.querySelectorAll('.featured-blog__card')) : [];
          this.emptyMessage = this.section ? this.section.querySelector('.featured-blog__empty') : null;
          this.sliderEl = this.section ? this.section.querySelector('.featured-blog__slider') : null;
          this.predictiveSearchUrl = this.dataset.predictiveSearchUrl;
          this.abortController = null;
          this.debounceTimer = null;

          if (this.input) {
            this.input.addEventListener('input', () => {
              clearTimeout(this.debounceTimer);
              const query = this.input.value.trim();
              this.debounceTimer = setTimeout(() => this.filter(query), 200);
            });
          }
        }

        filter(query) {
          if (this.abortController) this.abortController.abort();

          if (!query) {
            this.setLoading(false);
            this.showCards(this.cards);
            return;
          }

          this.setLoading(true);
          const controller = new AbortController();
          this.abortController = controller;
          const url = `${this.predictiveSearchUrl}.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=10&resources[options][fields]=title,body,tag`;

          fetch(url, { signal: controller.signal })
            .then((response) => response.json())
            .then((data) => {
              const matches = new Set(
                ((data.resources && data.resources.results && data.resources.results.articles) || []).map((article) =>
                  String(article.id)
                )
              );
              this.showCards(this.cards.filter((card) => matches.has(card.dataset.articleId)));
            })
            .catch((error) => {
              if (error.name !== 'AbortError') this.showCards([]);
            })
            .finally(() => {
              if (this.abortController === controller) this.setLoading(false);
            });
        }

        setLoading(isLoading) {
          if (this.sliderEl) this.sliderEl.classList.toggle('is-loading', isLoading);
        }

        showCards(visibleCards) {
          const visibleSet = new Set(visibleCards);
          this.cards.forEach((card) => {
            card.hidden = !visibleSet.has(card);
          });
          if (this.emptyMessage) this.emptyMessage.hidden = visibleCards.length !== 0;

          const slider = this.section && this.section.querySelector('.featured-blog__list');
          if (slider) {
            slider.scrollTo({ left: 0 });
            slider.updateNavButtons();
          }

          // Card visibility is toggled via the `hidden` attribute, which the
          // slider-dots MutationObserver (childList only) doesn't see — nudge
          // it so the pagination bar rebuilds for the filtered set.
          const dots = this.section && this.section.querySelector('slider-dots');
          if (dots && typeof dots.refresh === 'function') dots.refresh();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-slider')) {
    customElements.define(
      'featured-collection-slider',
      class FeaturedCollectionSlider extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.track = this.querySelector('[data-track]');
          this.sentinel = this.querySelector('[data-sentinel]');
          this.loading = false;

          // `:scope >` matters here: a plain descendant selector would also
          // match a product card's own image-slider nav buttons (same
          // data-direction attributes), and since the "next" card slider-nav
          // button sits earlier in the DOM than this track's own next
          // button, an unscoped query would silently grab the wrong element.
          this.prevButton = this.querySelector(':scope > [data-direction="prev"]');
          this.nextButton = this.querySelector(':scope > [data-direction="next"]');

          [this.prevButton, this.nextButton].forEach((button) => {
            if (!button) return;
            button.addEventListener('click', () => {
              const direction = button.dataset.direction === 'prev' ? -1 : 1;
              this.scrollToAdjacentCard(direction);
            });
          });

          this.updateCentering();
          this.updateNavButtons();
          this.track.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
          window.addEventListener('resize', () => {
            this.updateCentering();
            this.updateNavButtons();
          });

          if (this.sentinel) {
            this.observer = new IntersectionObserver(
              (entries) => {
                if (entries[0].isIntersecting) this.loadMore();
              },
              { root: this.track, rootMargin: '0px 600px 0px 0px', threshold: 0 }
            );
            this.observer.observe(this.sentinel);
          }
        }

        // When the whole collection is loaded and every card fits inside the
        // page margins (e.g. 4 products on a 1920px screen), centre the row
        // instead of leaving a gap on the right. Never while more pages are
        // still to load — those cards would land in the gap.
        updateCentering() {
          const cards = this.getCards();
          const hasMorePages = Boolean(this.sentinel && this.sentinel.dataset.nextPage);
          if (!cards.length || hasMorePages) {
            this.track.classList.remove('is-centered');
            return;
          }

          const trackStyle = getComputedStyle(this.track);
          const gap = parseFloat(trackStyle.columnGap) || 0;
          const pageMargin = parseFloat(trackStyle.paddingInlineStart) || 0;
          const rowWidth =
            cards.reduce((total, card) => total + card.getBoundingClientRect().width, 0) + gap * (cards.length - 1);

          this.track.classList.toggle('is-centered', rowWidth + pageMargin * 2 <= this.track.clientWidth);
        }

        getCards() {
          return Array.from(this.track.querySelectorAll('.product-card'));
        }

        updateNavButtons() {
          const cards = this.getCards();
          if (!cards.length) return;

          // Cards are start-snapped, so the track's real travel is the full
          // scrollWidth − clientWidth; hide each arrow once there's nothing
          // left that way.
          const maxScrollLeft = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          if (this.prevButton) this.prevButton.hidden = this.track.scrollLeft <= 1;
          if (this.nextButton) this.nextButton.hidden = this.track.scrollLeft >= maxScrollLeft - 1;
        }

        scrollToAdjacentCard(direction) {
          const card = this.track.querySelector('.product-card');
          if (!card) return;

          // A plain relative step of one card + gap; scroll-snap-align:
          // start on each card settles the rest position regardless of
          // exactly how far this step lands.
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card.getBoundingClientRect().width + gap;
          this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
        }

        loadMore() {
          const nextPage = this.sentinel.dataset.nextPage;
          if (!nextPage || this.loading) return;
          this.loading = true;

          const url = new URL(window.location.href);
          url.searchParams.set('page', nextPage);
          url.searchParams.set('section_id', this.sectionId);

          fetch(url.toString())
            .then((response) => response.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const freshSentinel = doc.querySelector('[data-sentinel]');
              const freshCards = doc.querySelectorAll('[data-track] .product-card');

              freshCards.forEach((card) => this.track.insertBefore(card, this.sentinel));
              this.sentinel.dataset.nextPage = freshSentinel ? freshSentinel.dataset.nextPage : '';

              if (!this.sentinel.dataset.nextPage && this.observer) {
                this.observer.unobserve(this.sentinel);
              }

              this.loading = false;
              this.updateCentering();
              this.updateNavButtons();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('[data-search-toggle]');
    var bar = document.querySelector('[data-search-bar]');
    if (!toggle || !bar) return;

    var input = bar.querySelector('.header__search-input');
    var closeButton = bar.querySelector('[data-search-close]');

    function open() {
      bar.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }

    function close() {
      bar.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (bar.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        close();
        toggle.focus();
      });
    }

    bar.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        toggle.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!bar.classList.contains('is-open')) return;
      if (bar.contains(event.target) || toggle.contains(event.target)) return;
      close();
    });
  })();

  /* Drop shadow on the sticky header once the page is scrolled. */
  (function () {
    var header = document.querySelector('.shopify-section.section-header');
    if (!header) return;

    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 0);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('instagram-slider')) {
    customElements.define(
      'instagram-slider',
      class InstagramSlider extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.instagram');
          if (!section) return;

          this.prevButton = section.querySelector('[data-direction="prev"]');
          this.nextButton = section.querySelector('[data-direction="next"]');

          section.querySelectorAll('[data-direction]').forEach((button) => {
            button.addEventListener('click', () => {
              const card = this.querySelector('.instagram-card');
              const distance = card ? card.getBoundingClientRect().width + 24 : this.clientWidth;
              const direction = button.dataset.direction === 'prev' ? -1 : 1;
              this.scrollBy({ left: distance * direction, behavior: 'smooth' });
            });
          });

          this.updateNavButtons();
          this.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
          window.addEventListener('resize', () => this.updateNavButtons());
        }

        updateNavButtons() {
          const maxScrollLeft = this.scrollWidth - this.clientWidth;
          if (this.prevButton) this.prevButton.hidden = this.scrollLeft <= 0;
          if (this.nextButton) this.nextButton.hidden = this.scrollLeft >= maxScrollLeft - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-ticker')) {
    customElements.define(
      'marquee-ticker',
      class MarqueeTicker extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.marquee__track');
          this.group = this.track && this.track.querySelector('.marquee__group');
          if (!this.group) return;

          this.speed = Math.max(Number(this.dataset.speed) || 50, 1);
          this.scheduleUpdate = this.scheduleUpdate.bind(this);

          // Re-measure when the bar resizes (viewport) or the original group
          // does (fonts loading, editor text edits that change width)...
          this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
          this.resizeObserver.observe(this);
          this.resizeObserver.observe(this.group);

          // ...and rebuild the clones whenever the original items change in
          // the theme editor, even if the width happens to stay the same.
          this.mutationObserver = new MutationObserver(this.scheduleUpdate);
          this.mutationObserver.observe(this.group, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
          });

          // Hold still while a merchant has one of this section's items
          // selected in the theme editor.
          this.onBlockSelect = (event) => {
            if (this.contains(event.target)) this.classList.add('is-paused');
          };
          this.onBlockDeselect = (event) => {
            if (this.contains(event.target)) this.classList.remove('is-paused');
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.mutationObserver) this.mutationObserver.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        scheduleUpdate() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        }

        update() {
          const groupWidth = this.group.getBoundingClientRect().width;

          this.track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());

          if (!groupWidth || !this.group.children.length) {
            this.classList.remove('is-animating');
            return;
          }

          // Enough repeats that the track still overfills the bar when it's
          // shifted left by a full group width at the end of each loop.
          const copies = Math.ceil(this.clientWidth / groupWidth) + 1;

          for (let i = 0; i < copies; i++) {
            const clone = this.group.cloneNode(true);
            clone.dataset.marqueeClone = '';
            clone.setAttribute('aria-hidden', 'true');
            clone.inert = true;
            clone.querySelectorAll('[data-shopify-editor-block], [id]').forEach((element) => {
              element.removeAttribute('data-shopify-editor-block');
              element.removeAttribute('id');
            });
            this.track.appendChild(clone);
          }

          // Mutations caused by our own clone swap aren't interesting.
          if (this.mutationObserver) this.mutationObserver.takeRecords();

          this.style.setProperty('--marquee-distance', `${groupWidth}px`);
          this.style.setProperty('--marquee-duration', `${groupWidth / this.speed}s`);
          this.classList.add('is-animating');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  if (!customElements.get('password-dialog')) {
    customElements.define(
      'password-dialog',
      class PasswordDialog extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');

          document.querySelectorAll('[data-password-dialog-open]').forEach((trigger) => {
            trigger.addEventListener('click', () => this.dialog.showModal());
          });

          this.querySelector('[data-password-dialog-close]').addEventListener('click', () => this.dialog.close());

          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          if (this.dialog.dataset.autoopen === 'true') this.dialog.showModal();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-accordion')) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = 300;
    const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';

    class ProductAccordionItem {
      constructor(details) {
        this.details = details;
        this.summary = details.querySelector('summary');
        this.wrapper = details.querySelector('.product-accordion-item__content-wrapper');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        this.details.dataset.expanded = this.details.open ? 'true' : 'false';
        this.summary.addEventListener('click', (event) => this.onClick(event));
      }

      onClick(event) {
        if (reduceMotion || !this.wrapper) return;
        event.preventDefault();

        this.details.dataset.expanded = this.details.open && !this.isClosing ? 'false' : 'true';

        if (this.isClosing || !this.details.open) {
          this.expand();
        } else if (this.isExpanding || this.details.open) {
          this.shrink();
        }
      }

      shrink() {
        this.isClosing = true;
        const startHeight = `${this.wrapper.offsetHeight}px`;
        if (this.animation) this.animation.cancel();
        this.animation = this.wrapper.animate({ height: [startHeight, '0px'] }, { duration, easing });
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => {
          this.isClosing = false;
        };
      }

      expand() {
        this.wrapper.style.height = `${this.wrapper.offsetHeight}px`;
        this.details.open = true;
        window.requestAnimationFrame(() => {
          this.isExpanding = true;
          const startHeight = `${this.wrapper.offsetHeight}px`;
          const endHeight = `${this.wrapper.scrollHeight}px`;
          if (this.animation) this.animation.cancel();
          this.animation = this.wrapper.animate({ height: [startHeight, endHeight] }, { duration, easing });
          this.animation.onfinish = () => this.onAnimationFinish(true);
          this.animation.oncancel = () => {
            this.isExpanding = false;
          };
        });
      }

      onAnimationFinish(open) {
        this.details.open = open;
        this.details.dataset.expanded = open ? 'true' : 'false';
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.wrapper.style.height = '';
      }
    }

    customElements.define(
      'product-accordion',
      class ProductAccordion extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('details').forEach((item) => new ProductAccordionItem(item));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-timetable"] && !Shopify.designMode) return;
  try {
    
  // The "Secure yours" scroll-up lives in snippets/scroll-to-top.liquid.

  if (!customElements.get('production-timetable-loader')) {
    customElements.define(
      'production-timetable-loader',
      class ProductionTimetableLoader extends HTMLElement {
        connectedCallback() {
          this.rows = this.querySelector('[data-rows]');
          this.onCandleHolderChanged = (event) => this.load(event.detail.url);
          document.addEventListener('candle-holder:changed', this.onCandleHolderChanged);
        }

        disconnectedCallback() {
          document.removeEventListener('candle-holder:changed', this.onCandleHolderChanged);
        }

        // Stays hidden until the first pick that comes back with rows. After
        // that, the previous rows stay on screen (dimmed under a spinner)
        // during each fetch, so switching holders never blanks the section
        // or shifts the layout. A holder without a timetable hides it again.
        // Only the most recently requested url's response is applied, so an
        // earlier request that resolves late can't overwrite a newer pick.
        load(url) {
          this.requestedUrl = url;

          if (!url) {
            this.hidden = true;
            this.classList.remove('is-loading');
            return;
          }

          if (!this.hidden) this.classList.add('is-loading');

          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              if (this.requestedUrl !== url) return;

              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fetchedRows = doc.querySelector('.production-timetable-section__rows');
              const rowsHtml = fetchedRows ? fetchedRows.innerHTML.trim() : '';

              if (rowsHtml) {
                this.rows.innerHTML = rowsHtml;
                this.hidden = false;
              } else {
                this.rows.innerHTML = '';
                this.hidden = true;
              }
            })
            .catch(() => {})
            .finally(() => {
              if (this.requestedUrl !== url) return;
              this.classList.remove('is-loading');
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('related-products')) {
    customElements.define(
      'related-products',
      class RelatedProducts extends HTMLElement {
        connectedCallback() {
          this.initSlider();

          // No data-url = merchant-set collection override, nothing to fetch.
          if (!this.dataset.url) return;

          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.observer.disconnect();
              this.load();
            },
            { rootMargin: '0px 0px 400px 0px' }
          );
          this.observer.observe(this);
        }

        // Re-fetches this section through the recommendations endpoint. If
        // Shopify has real recommendation cards for this product now, they
        // replace whatever's currently in the track (the type-based
        // fallback, most likely). If not, this is a silent no-op — the
        // fallback already on the page just stays put.
        load() {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const fetchedTrack = doc.querySelector('related-products [data-track]');
              const cards = fetchedTrack ? fetchedTrack.querySelectorAll('.product-card') : [];
              if (!cards.length) return;

              const track = this.querySelector('[data-track]');
              if (!track) return;

              track.innerHTML = fetchedTrack.innerHTML;
              this.hidden = false;
              this.initSlider();
            })
            .catch(() => {});
        }

        // Safe to call more than once (e.g. after load() swaps the track's
        // contents) — button click/scroll/resize listeners are bound only
        // on the first call, guarded by sliderBound; later calls just
        // refresh the prev/next hidden state against the current cards.
        initSlider() {
          const track = this.querySelector('[data-track]');
          if (!track) return;
          this.track = track;

          if (!this.sliderBound) {
            this.sliderBound = true;
            this.prevButton = this.querySelector('[data-direction="prev"]');
            this.nextButton = this.querySelector('[data-direction="next"]');

            [this.prevButton, this.nextButton].forEach((button) => {
              if (!button) return;
              button.addEventListener('click', () => {
                const card = this.track.querySelector('.product-card');
                if (!card) return;
                const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
                const distance = card.getBoundingClientRect().width + gap;
                const direction = button.dataset.direction === 'prev' ? -1 : 1;
                this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
              });
            });

            this.track.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
            window.addEventListener('resize', () => this.updateNavButtons());
          }

          this.updateNavButtons();
        }

        updateNavButtons() {
          const cards = Array.from(this.track.querySelectorAll('.product-card'));
          if (!cards.length) return;
          // Cards are start-snapped, so the track's real travel is the full
          // scrollWidth − clientWidth; hide each arrow at its end of that.
          const maxScrollLeft = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          if (this.prevButton) this.prevButton.hidden = this.track.scrollLeft <= 1;
          if (this.nextButton) this.nextButton.hidden = this.track.scrollLeft >= maxScrollLeft - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scrolling-cards-slider')) {
    customElements.define(
      'scrolling-cards-slider',
      class ScrollingCardsSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;

          this.prevButton = this.querySelector(':scope > [data-direction="prev"]');
          this.nextButton = this.querySelector(':scope > [data-direction="next"]');

          [this.prevButton, this.nextButton].forEach((button) => {
            if (!button) return;
            button.addEventListener('click', () => {
              const card = this.track.querySelector('.scrolling-cards__card');
              const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
              const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
              const direction = button.dataset.direction === 'prev' ? -1 : 1;
              this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
            });
          });

          this.updateNavButtons();
          this.track.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
          window.addEventListener('resize', () => this.updateNavButtons());
        }

        updateNavButtons() {
          const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;
          if (this.prevButton) this.prevButton.hidden = this.track.scrollLeft <= 0;
          if (this.nextButton) this.nextButton.hidden = this.track.scrollLeft >= maxScrollLeft - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-by-category-slider')) {
    customElements.define(
      'shop-by-category-slider',
      class ShopByCategorySlider extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.shop-by-category');
          if (!section) return;

          this.prevButton = section.querySelector('[data-direction="prev"]');
          this.nextButton = section.querySelector('[data-direction="next"]');

          section.querySelectorAll('[data-direction]').forEach((button) => {
            button.addEventListener('click', () => {
              const card = this.querySelector('.category-card');
              const distance = card ? card.getBoundingClientRect().width + 16 : this.clientWidth;
              const direction = button.dataset.direction === 'prev' ? -1 : 1;
              this.scrollBy({ left: distance * direction, behavior: 'smooth' });
            });
          });

          this.updateNavButtons();
          this.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
          window.addEventListener('resize', () => this.updateNavButtons());
        }

        updateNavButtons() {
          const maxScrollLeft = this.scrollWidth - this.clientWidth;
          if (this.prevButton) this.prevButton.hidden = this.scrollLeft <= 0;
          if (this.nextButton) this.nextButton.hidden = this.scrollLeft >= maxScrollLeft - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-faq')) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = 300;
    const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';

    class FaqItem {
      constructor(details) {
        this.details = details;
        this.summary = details.querySelector('summary');
        this.wrapper = details.querySelector('.faq-item__answer-wrapper');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        this.details.dataset.expanded = this.details.open ? 'true' : 'false';
        this.summary.addEventListener('click', (event) => this.onClick(event));
      }

      onClick(event) {
        if (reduceMotion || !this.wrapper) return;
        event.preventDefault();

        this.details.dataset.expanded = this.details.open && !this.isClosing ? 'false' : 'true';

        if (this.isClosing || !this.details.open) {
          this.expand();
        } else if (this.isExpanding || this.details.open) {
          this.shrink();
        }
      }

      shrink() {
        this.isClosing = true;
        const startHeight = `${this.wrapper.offsetHeight}px`;
        if (this.animation) this.animation.cancel();
        this.animation = this.wrapper.animate({ height: [startHeight, '0px'] }, { duration, easing });
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => {
          this.isClosing = false;
        };
      }

      expand() {
        // Pin the wrapper's current (collapsed) height as an inline style
        // before flipping `open` — otherwise the CSS fallback rule
        // `[open] .faq-item__answer-wrapper { height: auto }` snaps it to
        // full height immediately, so the rAF callback below would measure
        // an already-equal start/end height and nothing would animate.
        this.wrapper.style.height = `${this.wrapper.offsetHeight}px`;
        this.details.open = true;
        window.requestAnimationFrame(() => {
          this.isExpanding = true;
          const startHeight = `${this.wrapper.offsetHeight}px`;
          const endHeight = `${this.wrapper.scrollHeight}px`;
          if (this.animation) this.animation.cancel();
          this.animation = this.wrapper.animate({ height: [startHeight, endHeight] }, { duration, easing });
          this.animation.onfinish = () => this.onAnimationFinish(true);
          this.animation.oncancel = () => {
            this.isExpanding = false;
          };
        });
      }

      onAnimationFinish(open) {
        this.details.open = open;
        this.details.dataset.expanded = open ? 'true' : 'false';
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.wrapper.style.height = '';
      }
    }

    customElements.define(
      'tabbed-faq',
      class TabbedFaq extends HTMLElement {
        connectedCallback() {
          this.nav = this.querySelector('[data-tabs-nav]');
          this.panels = this.querySelectorAll('[data-tab-panel]');
          if (!this.nav || !this.panels.length) return;

          // Four tabs read better as a 2x2 grid than a wrapping row.
          if (this.panels.length === 4) {
            this.nav.classList.add('tabbed-faq__tabs--grid');
          }

          // The active panel on load is set server-side (the section's
          // `default_tab` setting, see blocks/faq-tab.liquid); fall back to
          // the first one if none rendered active.
          if (![...this.panels].some((panel) => panel.classList.contains('is-active'))) {
            this.panels[0].classList.add('is-active');
          }

          this.panels.forEach((panel) => {
            const id = panel.dataset.tabPanel;
            const isActive = panel.classList.contains('is-active');

            const trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.className = 'tabbed-faq__tab' + (isActive ? ' is-active' : '');
            trigger.setAttribute('role', 'tab');
            trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
            trigger.dataset.tabTrigger = id;
            trigger.textContent = panel.dataset.tabLabel;
            trigger.addEventListener('click', () => this.select(id));

            this.nav.append(trigger);

            const items = panel.querySelectorAll('details.faq-item');
            items.forEach((item) => new FaqItem(item));
          });

          this.triggers = this.nav.querySelectorAll('[data-tab-trigger]');
        }

        select(id) {
          this.triggers.forEach((trigger) => {
            const isActive = trigger.dataset.tabTrigger === id;
            trigger.classList.toggle('is-active', isActive);
            trigger.setAttribute('aria-selected', isActive);
          });

          this.panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.tabPanel === id);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-featured-products')) {
    customElements.define(
      'tabbed-featured-products',
      class TabbedFeaturedProducts extends HTMLElement {
        connectedCallback() {
          this.nav = this.querySelector('[data-tabs-nav]');
          this.panels = this.querySelectorAll('[data-tab-panel]');
          if (!this.nav || !this.panels.length) return;

          this.panels.forEach((panel, index) => {
            const id = panel.dataset.tabPanel;

            const trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.className = 'tabbed-featured-products__tab' + (index === 0 ? ' is-active' : '');
            trigger.setAttribute('role', 'tab');
            trigger.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
            trigger.dataset.tabTrigger = id;
            trigger.textContent = panel.dataset.tabLabel;
            trigger.addEventListener('click', () => this.select(id));

            this.nav.append(trigger);
          });

          this.triggers = this.nav.querySelectorAll('[data-tab-trigger]');
        }

        select(id) {
          this.triggers.forEach((trigger) => {
            const isActive = trigger.dataset.tabTrigger === id;
            trigger.classList.toggle('is-active', isActive);
            trigger.setAttribute('aria-selected', isActive);
          });

          this.panels.forEach((panel) => {
            const isActive = panel.dataset.tabPanel === id;
            const wasActive = panel.classList.contains('is-active');

            panel.classList.toggle('is-active', isActive);

            if (isActive) {
              // Returning to a panel whose exit fade is still running: drop the
              // leaving state (and its pending listener) so it can never hold
              // is-active + is-leaving at once — that combo makes the only
              // in-flow panel position:absolute and collapses the grid row.
              panel.classList.remove('is-leaving');
              if (panel._leaveHandler) {
                panel.removeEventListener('transitionend', panel._leaveHandler);
                panel._leaveHandler = null;
              }
            } else if (wasActive) {
              panel.classList.add('is-leaving');
              panel._leaveHandler = (event) => {
                // Ignore transitionend bubbling up from descendant elements.
                if (event.target !== panel) return;
                panel.classList.remove('is-leaving');
                panel.removeEventListener('transitionend', panel._leaveHandler);
                panel._leaveHandler = null;
              };
              panel.addEventListener('transitionend', panel._leaveHandler);
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-hero')) {
    customElements.define(
      'video-hero',
      class VideoHero extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.playButton = this.querySelector('[data-video-hero-play]');
          if (!this.video || !this.playButton) return;

          this.sourceTemplates = {
            desktop: this.querySelector('[data-video-hero-sources="desktop"]'),
            mobile: this.querySelector('[data-video-hero-sources="mobile"]'),
          };
          // Matches the 750px breakpoint the section's stylesheet uses.
          this.desktopQuery = window.matchMedia('(min-width: 750px)');
          this.currentMode = null;
          this.applySources();

          // Re-pick the source set when crossing the breakpoint, but only
          // until the viewer commits to playback — after that the native
          // control bar owns the element and a reload would interrupt it.
          this.desktopQuery.addEventListener('change', () => {
            if (!this.classList.contains('has-started')) this.applySources();
          });

          this.playButton.addEventListener('click', () => this.video.play());

          // First play locks in the current source set (see the breakpoint
          // listener above) and switches on the native control bar for good.
          this.video.addEventListener(
            'play',
            () => {
              this.classList.add('has-started');
              this.video.controls = true;
            },
            { once: true }
          );

          // The poster / play-button / caption overlay tracks the play
          // state: gone while the video runs, back on a genuine pause. The
          // pause reveal is deferred and re-checked against `seeking` so the
          // split-second pause the browser fires mid-scrub doesn't flash the
          // overlay over the control bar. No click-to-pause of our own — it
          // would swallow taps meant for the control bar.
          const scheduleOverlay = () => {
            clearTimeout(this.overlayTimer);
            this.overlayTimer = setTimeout(() => {
              if (this.video.paused && !this.video.seeking) {
                this.classList.remove('is-playing');
              }
            }, 120);
          };
          const hideOverlay = () => {
            clearTimeout(this.overlayTimer);
            this.classList.add('is-playing');
          };

          this.video.addEventListener('play', hideOverlay);
          this.video.addEventListener('playing', hideOverlay);
          this.video.addEventListener('seeking', () => clearTimeout(this.overlayTimer));
          this.video.addEventListener('pause', scheduleOverlay);
          this.video.addEventListener('seeked', () => {
            if (this.video.paused) scheduleOverlay();
          });
        }

        applySources() {
          const mode = this.desktopQuery.matches ? 'desktop' : 'mobile';
          if (mode === this.currentMode) return;
          this.currentMode = mode;

          const template = this.sourceTemplates[mode];
          const poster = mode === 'mobile' ? this.dataset.mobilePoster : this.dataset.desktopPoster;

          this.video.querySelectorAll('source').forEach((source) => source.remove());
          if (template && template.content) {
            this.video.appendChild(template.content.cloneNode(true));
          }
          if (poster) this.video.poster = poster;
          this.video.load();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
